const color_states = document.getElementsByName("color_checkbox");
const color_picker_error = document.getElementById("color_picker_error");

function checkSelectedColorsCount() {
  let count = 0;
  color_states.forEach(color => {
    if (color.checked) count += 1;
  });
  color_picker_error.style.display = count ? "none" : "block";
  return count > 3 ? false : true;
}
